import { ADMIN_VIEW_PREFIX } from './routes'

/**
 * Rota "pai" na hierarquia de telas — o destino do botão de voltar quando não
 * existe histórico dentro do app.
 *
 * O voltar não pode ser um `router.back()` cego. Quando a tela é aberta direto
 * — link do painel para a aula, link compartilhado, refresh da página — o app
 * nasce com uma única entrada na pilha, `canGoBack()` é false, e o fallback
 * antigo EMPILHAVA a página do curso. Aí a página do curso passava a ter
 * histórico e o voltar dela caía de volta na aula: pingue-pongue entre as duas
 * telas, sem nunca chegar na home.
 *
 * Subir com `router.replace` para este destino mantém a pilha do tamanho de um,
 * então o voltar da tela de cima também sobe em vez de descer.
 */
const RULES: Array<[RegExp, (m: RegExpExecArray) => string]> = [
  // Visão do produtor
  [
    /^\/admin_view\/courses\/(\d+)\/(course_contents\/\d+|extra_contents)$/,
    (m) => `${ADMIN_VIEW_PREFIX}/courses/${m[1]}`,
  ],
  [/^\/admin_view\/courses\/\d+$/, () => ADMIN_VIEW_PREFIX],

  // Aluno
  [
    /^(\/enrollments\/\d+\/courses\/\d+\/online_course\/course_contents\/\d+)\/image_viewer$/,
    (m) => m[1],
  ],
  [
    /^(\/enrollments\/\d+\/courses\/\d+\/online_course)\/(course_contents\/\d+|extra_contents)$/,
    (m) => m[1],
  ],
  [/^\/enrollments\/\d+\/courses\/\d+\/online_course$/, () => '/'],
  [/^\/enrollments\/\d+\/paths\/\d+$/, () => '/'],

  // Demais telas de primeiro nível
  [/^\/orders\/\d+\/payments$/, () => '/orders'],
  [/^\/channels\/(new|\d+)$/, () => '/channels'],
]

/**
 * Destino de "subir um nível" a partir de `pathname`, ou `null` quando a tela
 * já é raiz (home do aluno, home do preview) e não há para onde subir.
 */
export function parentPath(pathname: string): string | null {
  for (const [pattern, resolve] of RULES) {
    const match = pattern.exec(pathname)
    if (match) return resolve(match)
  }

  return null
}
